// API Configuration
// This file centralizes API URL management for different environments

/**
 * API Base URL
 * - Must be set in .env as REACT_APP_API_URL
 * - Used for SendGrid email integration
 * 
 * Usage:
 *   import { API_URL } from '../utils/apiConfig';
 *   fetch(`${API_URL}/api/endpoint`, { ... });
 */
export const API_URL = process.env.REACT_APP_API_URL || '';

/**
 * Helper function to build full API endpoint URLs
 * @param {string} endpoint - API endpoint path (e.g., '/api/test-email')
 * @returns {string} Full API URL
 */
export const getApiUrl = (endpoint) => {
  if (!API_URL) {
    console.warn('[API Config] No API_URL configured. Set REACT_APP_API_URL in .env');
    return '';
  }
  const baseUrl = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${path}`;
};

/**
 * Get current environment
 * @returns {'production'|'development'} Current environment
 */
export const getEnvironment = () => {
  return process.env.NODE_ENV === 'production' ? 'production' : 'development';
};


